import React from 'react';
import { CheckIcon, ZapIcon, GlobeIcon, BrainCircuitIcon } from 'lucide-react';
const tiers = [{
  name: 'Core Voice & Text',
  price: '30',
  description: 'Essential nationwide VoLTE infrastructure for modern teams.',
  features: ['Unlimited Talk & Text', '10GB High-Speed Data', 'Native VoLTE Routing', 'eSIM Instant Activation', 'Standard Device Financing'],
  cta: 'Start Core Profile',
  highlight: false,
  icon: ZapIcon
}, {
  name: 'AVA Autonomous',
  price: '50',
  description: 'The complete AI-powered cellular suite for high-growth enterprises.',
  features: ['Everything in Core', 'Unlimited High-Speed Data', 'Llama 3.1 Transcription', 'Automated SMS Text-backs', 'AVA CRM Integration', 'Priority Fleet Support'],
  cta: 'Provision AVA Suite',
  highlight: true,
  icon: BrainCircuitIcon
}, {
  name: 'Global Fleet',
  price: 'Custom',
  description: 'Bespoke infrastructure for global operations and custom gateway nodes.',
  features: ['Global Roaming (200+ Countries)', 'Custom Gateway Nodes', 'Dedicated Infrastructure Manager', 'White-label SIM Branding', 'API-First Fleet Control', 'Custom SLA Guarantees'],
  cta: 'Contact Sales',
  highlight: false,
  icon: GlobeIcon
}];
export function Pricing() {
  return <section id="business" className="py-20 bg-white" data-id="element-178">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-179">
        <div className="bg-black rounded-[2rem] p-12 lg:p-16 relative overflow-hidden" data-id="element-180">
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#13E200]/10 blur-[80px] rounded-full" data-id="element-181" />

          <div className="grid lg:grid-cols-2 gap-16 items-center relative z-10" data-id="element-182">
            <div data-id="element-183">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#13E200]/20 text-[#13E200] text-[10px] font-black uppercase tracking-widest mb-6" data-id="element-184">
                <BrainCircuitIcon className="w-4 h-4" data-id="element-185" />
                Business AI Suite
              </div>
              <h2 className="text-4xl lg:text-6xl font-black tracking-tighter text-white mb-6 uppercase italic leading-tight" data-id="element-186">
                Effy <span className="text-[#13E200]" data-id="element-187">Business</span>
              </h2>
              <p className="text-lg text-gray-400 mb-8 leading-relaxed font-bold uppercase tracking-wide" data-id="element-188">
                Native VoLTE network interception with real-time background AI
                transcription.
              </p>

              <div className="grid sm:grid-cols-2 gap-4 mb-8" data-id="element-189">
                {['AI Transcription', 'Intent Classification', 'Automated Text-backs', 'CRM Auto-Sync'].map((f, i) => <div key={i} className="flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-white/80" data-id="element-190">
                    <CheckIcon className="w-3 h-3 text-[#13E200]" data-id="element-191" />
                    {f}
                  </div>)}
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 border-4 border-[#13E200]" data-id="element-192">
              <div className="text-center mb-8" data-id="element-193">
                <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2" data-id="element-194">
                  Enterprise Tier
                </p>
                <div className="flex items-baseline justify-center gap-1" data-id="element-195">
                  <span className="text-6xl font-black text-black" data-id="element-196">$50</span>
                  <span className="text-gray-500 font-black uppercase tracking-widest text-xs" data-id="element-197">
                    /mo
                  </span>
                </div>
              </div>

              <button className="w-full cricket-btn-primary !text-lg" data-id="element-198">
                Join Business
              </button>

              <p className="text-center mt-4 text-[10px] font-bold text-gray-400 uppercase tracking-widest" data-id="element-199">
                Verification Required
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}